import type {IntroStep} from './types';

export enum IntroStepName {
  Mixpanel = `mixpanel`,
  Users = `users`,
  Events = `events`,
  Profiles = `profiles`,
  Complete = `complete`,
}

export const V2_STEPS: Array<Partial<IntroStep>> = [
  {
    name: IntroStepName.Mixpanel,
    text: `Mixpanel`,
    icon: `brand-mixpanel`,
  },
  {
    name: IntroStepName.Users,
    text: ({t}) => t(`mixology.user`, {context: `plural`}),
    icon: `profile`,
  },
  {
    name: IntroStepName.Events,
    text: ({t}) => t(`mixology.event`, {context: `plural`}),
    icon: `event`,
  },
  {
    name: IntroStepName.Profiles,
    text: ({t}) => t(`mixology.profile`, {context: `plural`}),
    icon: `profile`,
  },
  {
    name: IntroStepName.Complete,
  },
];

export enum IntroVersion {
  V1 = 1, // deprecated
  V2 = 2,
}
